import gql from 'graphql-tag'

export default gql`
  query getCentres($country: String!) {
    cfCentreCollection(where: { country: $country, status_not: "Closed" }) {
      items {
        title
        state
        country
        slug
        suburb
        status
        longitude
        latitude
      }
    }
  }
`
